import type { Settings } from '../meta/settings';

/** Apply DOM-level settings (reduced motion, quality hint). Audio/render read Settings themselves. */
export function applySettings(s: Settings): void {
  const root = document.documentElement;
  root.classList.toggle('sd-reduced-motion', s.reducedMotion);
  root.dataset.quality = s.quality;
}
